export const setReturnTo = (state=null, action) => {
  switch (action.type) {
    case 'SET_RETURN_TO':
      return action.returnTo;
    default:
      return state;
  }
}
